import { useEffect, useState } from "react";
import { IPost } from '../../Types/models';
import { useAuthContext } from "../../contexts/AuthContext";
import UserImage from "../UserImage";
import usePostService from "../../pages/services/postService";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from "js-cookie";
import CustomModal from "../Modals/CustomModal";
import { Button, Modal } from "react-bootstrap";
import useDateService from "../../pages/services/DateService";
import { POST_IMAGE_TAG } from "../../config";
import PostImage from "./PostImage";

interface IPostProps {
    post: IPost;
    // Liked: boolean;
    includedDetails?: boolean;
    isNew?: boolean;
    locale: string;
};

// const OpenShift = ({comment, Liked, includedDetails = false, isNew = false}: ICommentProps) => {
const Post = ({post, includedDetails = false, isNew = false, locale = "en"}: IPostProps) => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    const savedLang = Cookies.get('language');
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);
    // DATE SERVICES
    const {getTIMEZONE, getDateTimeWithTimezone} = useDateService();
    // HOME SETTINGS
    const TIMEZONE = getTIMEZONE();
    // const [isCommentLiked, setIsCommentLiked] = useState(false);
    // const {width} = useWindowDimensions();
    const {onDeletePost} = usePostService(post.comId, post.postId, null, null, null);
    // const {toggleComLiked, isComLiked} = useComLikeService(comment);
    // const navigation = useNavigation<HomeTabNavigationProp>();

    const deletePost = () => {
        setFooterModal(false);
        setContentModal(<>
        <Modal.Header closeButton>
            <Modal.Title>{t('post.areYouSure')}</Modal.Title>
            </Modal.Header>
        
            <Modal.Body>
                <p>{t('post.deleteMessage')}</p></Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                {t('shift.cancel')}
                </Button>
                {post?.room == post?.comId + "_posts" ?
                    <Button variant="primary" onClick={() => {onDeletePost(); setShowCustomModal(false);}}>{t('shift.confirm')}</Button>
                :
                    <Button variant="primary" onClick={() => {onDeletePost(AuthUserId); setShowCustomModal(false);}}>{t('shift.confirm')}</Button>
                }
            </Modal.Footer>
        </>);
        setShowCustomModal(true);
    };

    const getLanguage = () => {
        switch (savedLang) {
          case 'en':
            return enUS
          case 'fr':
            return fr
          default:
            return enUS
        }
    }

    // const createdAt = new Date(post?.createdAt);
    // createdAt.setHours(createdAt.getHours());

    const truncate = (str: string | undefined, maxlength: number) => {
        if (str) {
          return (str.length > maxlength) ?
          str.slice(0, maxlength - 1) + '…' : str;
        } else {
          return str;
        }
    };

    const isImage = (description: string | null | undefined) => {
        const isImg = post.description?.startsWith(POST_IMAGE_TAG);
        if (isImg) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            <CustomModal
                show={showCustomModal}
                onHide={() => setShowCustomModal(false)}
                link={linkModal}
                children={contentModal}
                isFooter={footerModal}
            />
            <div className="post" key={"post_"+ post?.postId}>
                { includedDetails &&
                    // <Image source={{uri: imageUri ||  DEFAULT_USER_IMAGE }} style={styles.avatar} />
                    
                    // <UserImage user={post?.user} avatarStyle={styles.avatar}/>
                    <UserImage user={post} customClass="userImage_sm shadow-sm hover:shadow-md" key={"worker_" + post.postId}/>
                    // <UserImage user={post?.user} customClass="userImage_sm shadow-sm hover:shadow-md" key={"worker_" + post.postId}/>
                }
                {/* <div>  */}
                    <span className="shiftText username">{truncate(post?.username, 20)}</span>
                    { isImage(post.description) ?
                        <PostImage post={post} image={post.description.split(POST_IMAGE_TAG)[1]} avatarStyle="postDescription" />
                    :
                        <p className="postDescription">{post.description}</p>
                    }
                    { includedDetails &&
                        <div className="post_footer">
                            {isNew && (<span className="new">{t('shift.new')}</span>)}
                            <p className="post_textFooter">{t('post.createdAt')}
                                {format(new Date(post?.createdAt), locale === "en" ? 'MMM c yyyy h:mm a' : 'd MMM yyyy, h:mm a', {locale: getLanguage()})}</p>
                            {post.userId == AuthUserId &&
                                <div className="deleteWrapper">
                                    <Link to={{}} className="deleteButton" onClick={deletePost} style={{}}>{t('post.delete')}</Link>
                                </div>
                            }
                        </div>
                    }
                {/* </div> */}
            </div>
        </>
    );
};

export default Post;